import { Popover } from 'antd';
import { Link } from 'react-router-dom';
import { Lock, IconProps } from 'react-feather';

import './style.less';

interface Props {
  redirect?: string;
  iconProps?: IconProps;
  disabled?: boolean;
}

const PermissionIcon: React.FC<Props> = ({ redirect, iconProps, disabled }) => {
  return (
    <Popover
      content={'Gerenciamento de permissões'}
      className="permission-icon"
    >
      {redirect && !disabled ? (
        <Link to={redirect}>
          <Lock size={20} cursor={'pointer'} {...iconProps} />
        </Link>
      ) : (
        <Lock
          size={20}
          cursor={disabled ? 'not-allowed' : 'pointer'}
          color={disabled ? 'gray' : undefined}
          {...iconProps}
        />
      )}
    </Popover>
  );
};

export default PermissionIcon;
